import {useListToolbarButton, useListToolbarButtonState} from "@udecode/plate-list/react";
import {ButtonWrapper} from "./_Button";

export const ListButton = ({format, children, ...restProps}) => {
    const state = useListToolbarButtonState({nodeType: format});
    const {props: buttonProps} = useListToolbarButton(state)

    return (
        <ButtonWrapper {...restProps} {...buttonProps}>
            {children}
        </ButtonWrapper>
    );
};